import { Customer } from "@/models/response/customer";
import { SmartAudienceListItemDto } from "@/models/club";
import { CustomerGroupResponse } from "@/models/response/customerGroup";
import { discountGroup, SmsTemplate } from "@/services/discount/type";
import { v4 as uuidv4 } from "uuid";
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export enum MessageType {
  all = "all",
  messageGroup = "messageGroup",
  custom = "custom",
}

export enum MessageGroupType {
  customerGroup = "customerGroup",
  discountGroup = "discountGroup",
  // A ready-made audience the server works out (GET /api/SmartAudience); only its key is sent.
  smartAudience = "smartAudience",
}

// `merchantUserId`: the team member whose customers it is, when a manager picked it from «برنامه‌ی من».
export type SmartAudienceChoice = SmartAudienceListItemDto & { merchantUserId?: number };

type SetTemplatePayload = {
  smsTemplate?: SmsTemplate;
};

type SetCustomerPayload = {
  type?: MessageType;
  customerGroup?: CustomerGroupResponse;
  discountGroup?: discountGroup;
  groupType?: MessageGroupType;
  customers?: Customer[];
  discountGroupCount?: number;
  smartAudience?: SmartAudienceChoice;
  excludeCustomerIds?: number[];
};

export type MessageStore = {
  id?: string;
  type?: MessageType;
  customerGroup?: CustomerGroupResponse;
  discountGroup?: discountGroup;
  discountGroupCount?: number;
  customers?: Customer[];
  smartAudience?: SmartAudienceChoice;
  // Customers of the smart audience the user unticked in «دیدن افراد».
  excludeCustomerIds?: number[];
  smsTemplate?: SmsTemplate;
  groupType?: MessageGroupType;
  setTemplate: (command: SetTemplatePayload) => void;
  setCustomers: (command: SetCustomerPayload) => void;
  clearMessage: () => void;
};

const useMessageStore = create<MessageStore>()(
  devtools(
    persist(
      (set) => ({
        type: undefined,
        group: undefined,
        customerIds: undefined,
        setTemplate: (command) =>
          set((state) => ({
            ...state,
            id: uuidv4(),
            smsTemplate: command?.smsTemplate,
          })),
        setCustomers: (command) =>
          set((state) => ({
            ...state,
            ...command,
          })),
        clearMessage: () =>
          set(() => ({
            id: undefined,
            type: undefined,
            customerGroup: undefined,
            discountGroup: undefined,
            discountGroupCount: undefined,
            customers: undefined,
            smartAudience: undefined,
            excludeCustomerIds: undefined,
            smsTemplate: undefined,
            groupType: undefined,
          })),
      }),
      { name: "createMessageState" }
    )
  )
);

export default useMessageStore;
